import React from 'react';

import PropTypes from 'prop-types';
import useProvideAuth from 'hooks/useProvideAuth';

import { AuthContext } from 'context/AuthContext';

export function AuthProvider({ children }) {
  const value = useProvideAuth();
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node,
};
